import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class ReportService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }

  getAgentChangeStatusForAgent = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.getAgentChangeStateForAgent,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAgentChangeStatusForAccount = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.getAgentChangeStateForAccount,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  restoreAgentChangeStatusForAccount = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.restoreAgentChangeState,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
}
